var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopyPasteIcon = function SvgCopyPasteIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10572_25876)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1199 6.75925H7.47764C7.08225 6.75925 6.76172 7.07977 6.76172 7.47517V15.1174C6.76172 15.5128 7.08225 15.8333 7.47764 15.8333H15.1199C15.5153 15.8333 15.8358 15.5128 15.8358 15.1174V7.47517C15.8358 7.07977 15.5153 6.75925 15.1199 6.75925Z",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.76056 13.2407H5.46426C4.74834 13.2407 4.16797 12.6604 4.16797 11.9444V5.46296C4.16797 4.74704 4.74834 4.16667 5.46426 4.16667H11.9457C12.6617 4.16667 13.242 4.74704 13.242 5.46296V6.75926",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10572_25876"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
export { SvgCopyPasteIcon as ReactComponent };
export default __webpack_public_path__ + "copy-paste-icon.svg";